import "./OurTeam.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useRef } from "react";
import { FaAngleDoubleLeft } from "react-icons/fa";
import { FaAngleDoubleRight } from "react-icons/fa";

import image1 from "../assets/image/work1.jpg";
import image2 from "../assets/image/work2.jpg";
import image3 from "../assets/image/work3.jpg";
import image4 from "../assets/image/corporate1.jpg";
import image5 from "../assets/image/corporate2.jpg";

const teamMembers = [
    { id: 1, image: image1 },
    { id: 2, image: image2 },
    { id: 3, image: image3 },
    { id: 4, image: image4 },
    { id: 5, image: image5 },
];

export default function OurTeam() {
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    return (
        <div className="our-team-section">
            <div className="section-title">
                <h1 >Meet Our Team</h1>
            </div>

            <div className="our-team-swiper-wrapper">
                <button ref={prevRef} className="custom-nav-button custom-nav-button-prev">
                    <FaAngleDoubleLeft />
                </button>
                <button ref={nextRef} className="custom-nav-button custom-nav-button-next">
                    <FaAngleDoubleRight />
                </button>

                <Swiper
                    modules={[Navigation]}
                    spaceBetween={30}
                    slidesPerView={1}
                    loop={true}
                    navigation={{
                        prevEl: prevRef.current,
                        nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                        swiper.params.navigation.prevEl = prevRef.current;
                        swiper.params.navigation.nextEl = nextRef.current;
                    }}
                    breakpoints={{
                        450: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 4 },
                    }}
                    className="our-team-swiper"
                >
                    {teamMembers.map((member) => (
                        <SwiperSlide key={member.id}>
                            <div className="team-card">
                                <img src={member.image} alt={`Team member ${member.id}`} className="team-image" />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
